import { format } from 'date-fns';

export const THERAPEUTIC_AREA_COLORS = [
  '#D24B4B',
  '#FF9D2E',
  '#69B8C7',
  '#5A8FCA',
  '#85CE59',
  '#9A44C1',
  '#F4A11A',
  '#44CDEB',
  '#DE4F36',
  '#3D8FBC',
  '#C4CAD8',
];

export function withSince(label, isoDate) {
  if (!isoDate) {
    return label;
  }
  return `${label} depuis le ${format(new Date(isoDate), 'dd/MM/yyyy')}`;
}

export function getTherapeuticAreaColor(index) {
  return THERAPEUTIC_AREA_COLORS[index % THERAPEUTIC_AREA_COLORS.length];
}

export function hexToRgba(hex, alpha) {
  const normalized = hex.replace('#', '');
  const red = parseInt(normalized.slice(0, 2), 16);
  const green = parseInt(normalized.slice(2, 4), 16);
  const blue = parseInt(normalized.slice(4, 6), 16);
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}

